import React from "react"
import { NavLink, useLocation, useNavigate } from "react-router-dom"

import { publicRoutes } from "router/routes"

import Header from "./Header/Header"
import Footer from "./Footer/Footer"
import { Logo } from "components/Elements/Logos/Logo"

import { useAuth, useOperator, usePageReducer } from "hooks"
import { HeaderWave } from "components/Elements"
import { isNotEmpty } from "utils/validation"
import { BICYCODE_ID } from "operators/bicycode/config"
import { MOUSTACHE_ID, MOUSTACHE_NAME } from "operators/moustache/config"

interface PublicLayoutProps {
	children?: React.ReactNode
	className?: string
	classNameMain?: string
}

const PublicLayout: React.FC<PublicLayoutProps> = ({
	children,
	className = "",
	classNameMain = "",
}) => {
	const { dispatchPageIsComplete, isComplete } = usePageReducer()
	const { isLoggedIn } = useAuth()
	const { currentOperator, isOperatorComplete } = useOperator()
	const location = useLocation()
	const navigate = useNavigate()

	const isBCOperator = currentOperator?.id === BICYCODE_ID
	const isMoustacheOperator = currentOperator?.name === MOUSTACHE_NAME

	React.useEffect(() => {
		if (isOperatorComplete) {
			if (isNotEmpty(currentOperator)) {
				// For the moment, a Moustache user just need to access to bike transfer request page => no need to redirect to the signin page
				if (location.pathname === "/" && !isMoustacheOperator)
					navigate(publicRoutes.signin.path)
			} else navigate(publicRoutes.notFound.path)
			dispatchPageIsComplete()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentOperator, isOperatorComplete])

	// L'opérateur Moustache utilise la plateforme obike_owner seulement pour le retour/rachat
	// On ne souhaite donc pas que le logo soit cliquable car il envoie vers la page de connexion de notre plateforme
	const isMCOperator = currentOperator?.id === MOUSTACHE_ID
	const isLogoClickable = !isMCOperator

	return (
		<div className={`min-h-screen flex flex-col overflow-x-hidden relative ${className}`}>
			{isComplete && (
				<>
					{isLoggedIn ? (
						<>
							<Header />
							{isBCOperator && <HeaderWave className="absolute top-0 left-0" />}
						</>
					) : (
						currentOperator && (
							<header className="z-10">
								{isLogoClickable && (
									<NavLink to="/">
										<Logo
											className={`${
												!isBCOperator && "lg:ml-6"
											} my-6 sm:my-6 max-w-full`}
											color="var(--primaryColor)"
											width="460"
										/>
									</NavLink>
								)}
								{!isLogoClickable && (
									<Logo
										className={`${
											!isBCOperator && "lg:ml-6"
										} my-6 sm:my-6 max-w-full`}
										color="var(--primaryColor)"
										width="460"
									/>
								)}
							</header>
						)
					)}

					<main
						role="main"
						className={`flex-1 px-4 relative flex flex-col ${classNameMain}`}
					>
						{children}
					</main>

					{!isMoustacheOperator && <Footer />}
				</>
			)}
		</div>
	)
}

export default PublicLayout
